(() => {
  const shell = document.querySelector('.hok-shell-header');
  const header = shell?.querySelector('#header');
  const productToggle = shell?.querySelector('#products-toggle');
  const productMenu = shell?.querySelector('#products-menu');
  const mobileToggle = shell?.querySelector('#mobile-toggle');
  const mobileMenu = shell?.querySelector('#mobile-menu');
  if (!header || !productToggle || !productMenu || !mobileToggle || !mobileMenu) return;

  const mobileViewport = window.matchMedia('(max-width: 960px)');

  function sizeNavigation() {
    const viewport = window.visualViewport;
    const viewportBottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
    const availableHeight = Math.max(120, viewportBottom - header.getBoundingClientRect().bottom);
    shell.style.setProperty('--hok-menu-height', `${availableHeight}px`);
  }

  function closeNavigation({ restoreFocus = false } = {}) {
    const activeToggle = !mobileMenu.hidden ? mobileToggle : !productMenu.hidden ? productToggle : null;
    productMenu.hidden = true;
    mobileMenu.hidden = true;
    productToggle.setAttribute('aria-expanded', 'false');
    mobileToggle.setAttribute('aria-expanded', 'false');
    mobileToggle.setAttribute('aria-label', 'Open navigation');
    if (restoreFocus && activeToggle) activeToggle.focus();
  }

  function openNavigation(menu, toggle, focusFirstLink = false) {
    closeNavigation();
    sizeNavigation();
    menu.hidden = false;
    menu.scrollTop = 0;
    toggle.setAttribute('aria-expanded', 'true');
    if (toggle === mobileToggle) toggle.setAttribute('aria-label', 'Close navigation');
    if (focusFirstLink) menu.querySelector('a')?.focus();
  }

  [[productToggle, productMenu], [mobileToggle, mobileMenu]].forEach(([toggle, menu]) => {
    toggle.addEventListener('click', event => {
      if (menu.hidden) openNavigation(menu, toggle, event.detail === 0);
      else closeNavigation();
    });
    toggle.addEventListener('keydown', event => {
      if (event.key !== 'ArrowDown') return;
      event.preventDefault();
      openNavigation(menu, toggle, true);
    });
  });

  document.addEventListener('click', event => {
    if (!shell.contains(event.target)) closeNavigation();
  });
  header.addEventListener('click', event => {
    if (event.target.closest('a')) closeNavigation();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || (productMenu.hidden && mobileMenu.hidden)) return;
    event.preventDefault();
    closeNavigation({ restoreFocus: true });
  });
  document.addEventListener('focusin', event => {
    if (!shell.contains(event.target)) closeNavigation();
  });
  // Browser toolbar changes resize the scrollable panel without closing it.
  window.addEventListener('resize', sizeNavigation, { passive: true });
  window.visualViewport?.addEventListener('resize', sizeNavigation, { passive: true });
  window.addEventListener('scroll', () => {
    if (!mobileMenu.hidden || !productMenu.hidden) sizeNavigation();
  }, { passive: true });
  mobileViewport.addEventListener('change', () => closeNavigation());
  window.addEventListener('pagehide', () => closeNavigation());
  window.addEventListener('hashchange', () => closeNavigation());
})();
